import React, { useEffect, useRef, useState } from 'react';
import Header from '../../../components/header';
import Layout from '../../../components/layout';
import { AgGridReact } from 'ag-grid-react';
import Icon from '../../../components/icons';
import Drawer from '../../../components/Drawer';
import Button from '../../../components/elements/button';
import { PAGE_SIZE } from '../../../_common/constant';
import Pagination from '../../../components/pagination';
import Search from '../../../components/search';
import Loader from '../../../components/loader';
import Filters from '../../../components/filters';
import { filterConfigType } from '../../../_config/types';
import { titleCell } from '../../../components/elements/function';
import toast from 'react-hot-toast';
import { useDialog } from '../../../store/api/hooks/dialogHook';
import { useCommonApi } from '../../../store/api/hooks/commonApiHook';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';
import CreateMasterServiceTech from './CreateMasterServiceTech';


const MasterServiceTech: React.FC = () => {
    const createDrawerRef: any = useRef();
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [searchParam, setSearchParam] = useState<string>('');
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const filtersRef: any = useRef();
    const [filters, setFilters] = useState<any>({});
    const [rowData, setRowData] = useState<any>(null);
    const [editData, setEditData] = useState<any>(null);
    const [filtersApplied, setFiltersApplied] = useState<any>({ generalFilter: false });
    const [filtersInitialized, setFiltersInitialized] = useState<boolean>(false);

    // Load filters from localStorage on component mount
    useEffect(() => {
        const savedFilters = localStorage.getItem('userServiceTechFilters');
        if (savedFilters) {
            try {
                const parsedFilters = JSON.parse(savedFilters);
                setFilters(parsedFilters);
            } catch (error) {
                console.error('Error parsing saved filters:', error);
                setFilters({});
            }
        } else {
            setFilters({});
        }
        setFiltersInitialized(true);
    }, []);

    // Save filters to localStorage when filters change
    useEffect(() => {
        if (Object.keys(filters).length > 0) {
            localStorage.setItem('userServiceTechFilters', JSON.stringify(filters));
        }
    }, [filters]);

    const addNewServiceTechRef: any = React.createRef<HTMLButtonElement>();
    const createServiceTechRef: any = useRef();

    const filterConfig: filterConfigType[] = [
        { name: 'Name', type: 'text', key: 'name' },
        { name: 'Service Tech ID', type: 'text', key: 'serviceTechID' },
        { name: 'Phone', type: 'text', key: 'phone' },
        { name: 'Email', type: 'text', key: 'email' },
    ];

    const { confirm } = useDialog();
    const commonApi: any = useCommonApi();
    const facilityApi: any = useFacilitiesApi();

    const onGridReady = (params: any) => {
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false);
        }
    };

    const columnDefs = [
        { headerName: 'Name', field: 'name', headerClass: 'bg-[#f0f0f0]', width: 450, cellRenderer: titleCell },
        { headerName: 'Phone', field: 'phone', headerClass: 'bg-[#f0f0f0]', width: 350, flex: 1 },
        { headerName: 'Email', field: 'emailID', headerClass: 'bg-[#f0f0f0]', minWidth: 350 },
        {
            headerName: "Actions",
            field: "actions",
            headerClass: 'bg-[#f0f0f0] text-center',
            width: 90,
            pinned: 'right',
            cellRenderer: (params: any) => {
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon name='threedote' size={1.25} className='text-[#000000]' onClick={(e: any) => {
                            e.stopPropagation();
                            e.preventDefault();
                            const dropdown: any = document.querySelector('.action-dropdown');
                            if (dropdown) {
                                dropdown.focus();
                            }
                            return false;
                        }} />
                        <select
                            onChange={(e) => {
                                let action = e.target.value;
                                handleActionChange(e, params);
                                //e.target.value = '';
                            }}
                            onFocus={(e) => {
                                e.target.selectedIndex = -1;
                            }
                            }
                            className="action-dropdown"
                            value={''}
                            style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                width: "100%",
                                height: "100%",
                                opacity: 0,
                                cursor: "pointer",
                            }}
                        >
                            <option value="edit">Edit</option>
                            <option value="delete">Delete</option>
                            
                        </select>
                    </div>
                );
            },

        }
    ];

    const handleActionChange = (e: any, params: any) => {
        const action = e.target.value;
        const rowData = params.data;

        switch (action) {
            case "edit":
                setEditData(rowData);
                addNewServiceTechRef.current.open();
                console.log("Edit action for service tech: ", rowData);
                break;
            case "delete":
                confirm({
                    type: 'delete',
                    title: 'Delete Service Tech',
                    message: `Are you sure you want to delete the service tech "${rowData.name}"?`,
                    onConfirm: () => {
                        facilityApi.deleteServiceTech(
                            { serviceTechID: rowData.serviceTechID },
                            (resp: any) => {
                                toast.success('Service Tech deleted successfully');
                                getUserServiceTechList();
                            },
                            (error: any) => {
                                console.error('Error deleting service tech:', error);
                                toast.error('Failed to delete Service Tech');
                            }
                        );
                    }
                });
                break;
            default:
                console.log("Unknown action: ", action);
                break;
        }
        e.target.selectedIndex = -1;
    };

    const getUserServiceTechList = () => {
        const payload: any = {
            pageSize: PAGE_SIZE,
            pageNumber: currentPage, // Changed from pageNumber to pageNo to match API pattern
            searchParam: searchParam,
        };

        if (filters) {
            Object.keys(filters).map((key: any) => {
                if (filters[key]) {
                    payload[key] = filters[key];
                }
            });
        }

        setRowData(null);

        commonApi.GetServicetectList(
            payload,
            (resp: any) => {
                if (resp && resp.serviceTechShortList && Array.isArray(resp.serviceTechShortList)) {
                    setRowData(resp.serviceTechShortList);
                    // Use totalRecord from API response for proper pagination
                    setTotalRecords(resp.totalRecord || resp.serviceTechShortList.length);
                } else {
                    setRowData([]);
                    setTotalRecords(0);
                }
            },
            (error: any) => {
                console.log("Error fetching service tech list:", error);
                toast.error(error || "Failed to fetch service tech list");
                setRowData([]);
                setTotalRecords(0);
            }
        );
    };

    // Call getUserServiceTechList when dependencies change
    useEffect(() => {
        if (filtersInitialized) {
            getUserServiceTechList();
        }

        const hasActiveFilters = filterConfig.some((filter) => filters[filter.key]);
        setFiltersApplied({
            generalFilter: hasActiveFilters,
        });
    }, [currentPage, searchParam, filters, filtersInitialized]);

    return (
        <Layout>
            <Header title="Master Service Tech List" back="/settings" >
                <Header.Right>
                    <Drawer _ref={addNewServiceTechRef} onClose={() => {
                        setEditData(null);
                        createServiceTechRef?.current?.reset()
                    }} outsideClose={false}>
                        <Drawer.Button>
                            <Button>{editData ? 'Edit' : 'Create'} Service Tech</Button>
                        </Drawer.Button>
                        <Drawer.Content title={editData ? 'Edit Service Tech' : 'Create New Service Tech'} className='!w-[39.563rem]'>
                            <CreateMasterServiceTech _ref={createServiceTechRef} editData={editData} onCreate={() => {
                                setEditData(null);
                                getUserServiceTechList();
                                addNewServiceTechRef?.current?.close();
                            }} onCancel={() => {
                                setEditData(null);
                                addNewServiceTechRef?.current?.close();
                            }} />
                        </Drawer.Content>
                    </Drawer>
                </Header.Right>
            </Header>
            <div className='flex items-center justify-between pl-5 pr-3 border-b border-gray-200 h-[3.75rem]'>
                <Pagination
                    perPage={PAGE_SIZE}
                    totalRecords={totalRecords}
                    onPageChange={setCurrentPage}
                    currentPage={currentPage}
                />
                {/* <Search onSearch={setSearchParam} placeholder='Search by name, ID, phone or email'/> */}
            </div>
            <div className='bg-[#FAFAFA] w-full'>
                {/* <div className='flex gap-4 px-5 py-2 items-center'>
                    <Button theme='light' onClick={() => filtersRef.current.showModal()}>Filter <Icon name='filter' size={1.40} className={filtersApplied.generalFilter ? "text-blue-700" : ""} /></Button>
                    <p className='text-primary font-semibold text-sm cursor-pointer' onClick={() => {
                        setFilters({});
                        localStorage.removeItem('userServiceTechFilters');
                        setFiltersApplied({ generalFilter: false });
                        setCurrentPage(1);
                    }} >Clear Filters</p>
                </div> */}
                <div className="ag-theme-alpine px-4 w-full h-1/2">
                    <AgGridReact
                        columnDefs={columnDefs as any}
                        rowData={rowData || []}
                        rowSelection="multiple"
                        onGridReady={onGridReady}
                        pagination={false}
                        domLayout="autoHeight"
                        onRowClicked={onRowClicked}
                        loadingOverlayComponent={Loader}
                        noRowsOverlayComponent={() => (
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center text-gray-500">
                                    <div className="text-lg font-medium">No Data Found</div>
                                </div>
                            </div>
                        )}
                    />
                </div>
            </div>
            <Filters _ref={filtersRef} config={filterConfig} filters={filters} onUpdate={setFilters} />
        </Layout>
    );
};

export default MasterServiceTech;